import { Component, ViewEncapsulation } from '@angular/core';
import { DumbInvoice } from './DTOs/dumb-invoice';
import { MemberInvoicesService } from './member-invoices.service';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { ToastNotificationService } from '../../core/toast-notification.service';
import { UIBlockingService } from '../../core/ui-blocking.service';
import { Observable, merge, scheduled, timeout } from 'rxjs';
import { MemberInvoicesDtRetInfo } from './DTOs/member-invoices-dt-ret-info';
import { GetInvoicesRequest } from './DTOs/get-invoices-request';
import { ActivatedRoute, Router } from '@angular/router';
import { DumbPaymentMethod } from '../membership-management/DTOs/dumb-payment-method';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SubmitPaymentRequest } from './DTOs/submit-payment-request';

@Component({
  selector: 'app-member-invoice-detailsls',
  templateUrl: './member-invoice-details.component.html',
  providers: [UIBlockingService, NgbDropdown],
  encapsulation: ViewEncapsulation.None
})
export class MemberInvoiceDetailsComponent {
  constructor(private invoiceService: MemberInvoicesService,
    private blockUI: UIBlockingService,
    private notificationService: ToastNotificationService,
    private route: ActivatedRoute,
    private router: Router) {
  }


  paymentTypeCtrl = new FormControl("paymentType");

  nameOnCardCtrl = new FormControl("nameOnCard");
  cardNumberCtrl = new FormControl("cardNumber");
  cardExpirationCtrl = new FormControl("cardExpiration");
  CVVCtrl = new FormControl("cvv");
  streetCtrl = new FormControl("street");
  street2Ctrl = new FormControl("street2");
  cityCtrl = new FormControl("city");
  stateCtrl = new FormControl("state");
  zipCtrl = new FormControl("zip");
  accountNameCtrl = new FormControl("accountName");
  routingNumberCtrl = new FormControl("routingNumber");
  accountNumber1Ctrl = new FormControl("accountNumber1");
  accountNumber2Ctrl = new FormControl("accountNumber2");

  paymentInfoForm: FormGroup = new FormGroup({
    nameOnCard: this.nameOnCardCtrl,
    paymentType: this.paymentTypeCtrl,
    cardNumber: this.cardNumberCtrl,
    cardExpiration: this.cardExpirationCtrl,
    cvv: this.CVVCtrl,
    street: this.streetCtrl,
    street2: this.street2Ctrl,
    city: this.cityCtrl,
    state: this.stateCtrl,
    zip: this.zipCtrl,
    accountName: this.accountNameCtrl,
    routingNumber: this.routingNumberCtrl,
    accountNumber1: this.accountNumber1Ctrl,
    accountNumber2: this.accountNumber2Ctrl,
  });

  paymentType() { return this.paymentInfoForm.get('paymentType').value }

  nameOnCard() { return this.paymentInfoForm.get('nameOnCard').value }
  cardNumber() { return this.paymentInfoForm.get('cardNumber').value }
  cardExpiration() { return this.paymentInfoForm.get('cardExpiration').value }
  cvv() { return this.paymentInfoForm.get('cvv').value }
  street() { return this.paymentInfoForm.get('street').value }
  street2() { return this.paymentInfoForm.get('street2').value }
  city() { return this.paymentInfoForm.get('city').value }
  state() { return this.paymentInfoForm.get('state').value }
  zip() { return this.paymentInfoForm.get('zip').value }

  accountName() { return this.paymentInfoForm.get('accountName').value }
  routingNumber() { return this.paymentInfoForm.get('routingNumber').value }
  accountNumber1() { return this.paymentInfoForm.get('accountNumber1').value }
  accountNumber2() { return this.paymentInfoForm.get('accountNumber2').value }
  accountNumbersMatchError: boolean = false;
  donationActive: boolean = true;
  paymentMethod: DumbPaymentMethod;
  invoiceIds: number[] = [];
  invoices: DumbInvoice[] = [];
  donationAmount: number = 50;

  get grandTotal() { return this.invoices.reduce((sum, current) => sum + current.amount, 0) + this.donationAmount; }

  ngOnInit() {
    var invoiceIdsString = this.route.snapshot.paramMap.get("invoiceIds");
    var split = invoiceIdsString.split(",");
    split.forEach(id => {
      this.invoiceIds.push(parseInt(id))
    });

    if (this.invoiceIds.length == 0) {
      this.notificationService.error("must have selected invoices to pay.");
      setTimeout(() => {
        return this.router.navigate(['/admin-portal/member/invoice-management']);
      }, 3000);
    }

    this.blockUI.start();
    this.getMemberInvoices().subscribe(
      {
        next: (data) => {
          console.log(data);
          this.invoices = data;
        },
        error: (err) => {
          this.notificationService.error(err.error.message);
          this.blockUI.stop();
          console.log(err)
        },
        complete: () => {
          this.blockUI.stop();
        }
      });
    this.getMemberPaymentMethod().subscribe(
      {
        next: (data) => {
          this.paymentMethod = data;
          this.resetPaymentInfoForm();
        },
        error: (err) => {
          this.notificationService.error(err.error.message);
          this.blockUI.stop();
          console.log(err)
        },
        complete: () => {
          this.blockUI.stop();
        }
      });
  }
  private resetPaymentInfoForm(): void {
    this.paymentInfoForm.reset();
    this.paymentInfoForm.get('paymentType').valueChanges.subscribe(val => {
      this.clearPaymentValidators();
      this.setPaymentValidators(val);
    });

    this.paymentInfoForm.patchValue({
      paymentType: 1,
    });
  }
  getMemberInvoices() {
    return this.invoiceService
      .getInvoicesListForPaying(this.invoiceIds);
  }

  getMemberPaymentMethod() {
    return this.invoiceService
      .getMemberPaymentMethod();
  }

  removeInvoiceFromList(invoice) {
    var indexInList = this.invoices.indexOf(invoice);
    if (indexInList >= 0)
      this.invoices.splice(indexInList, 1);

    indexInList = this.invoiceIds.indexOf(invoice.id);
    if (indexInList >= 0)
      this.invoiceIds.splice(indexInList, 1);
  }
  setPaymentValidators(val) {
    if (val == 1) {
      this.paymentInfoForm.get('nameOnCard').setValidators(Validators.required);
      this.paymentInfoForm.get('cardNumber').setValidators(Validators.required);
      this.paymentInfoForm.get('cardExpiration').setValidators(Validators.required);
      this.paymentInfoForm.get('cvv').setValidators(Validators.required);
      this.paymentInfoForm.get('street').setValidators(Validators.required);
      this.paymentInfoForm.get('city').setValidators(Validators.required);
      this.paymentInfoForm.get('state').setValidators(Validators.required);
      this.paymentInfoForm.get('zip').setValidators(Validators.required);
    }
    else if (val == 2) {
      this.paymentInfoForm.get('accountName').setValidators(Validators.required);
      this.paymentInfoForm.get('routingNumber').setValidators(Validators.required);
      this.paymentInfoForm.get('accountNumber1').setValidators(Validators.required);
      this.paymentInfoForm.get('accountNumber2').setValidators(Validators.required);
    }
    this.paymentInfoForm.get('accountName').updateValueAndValidity();
    this.paymentInfoForm.get('routingNumber').updateValueAndValidity();
    this.paymentInfoForm.get('accountNumber1').updateValueAndValidity();
    this.paymentInfoForm.get('accountNumber2').updateValueAndValidity();
    this.paymentInfoForm.get('nameOnCard').updateValueAndValidity();
    this.paymentInfoForm.get('cardNumber').updateValueAndValidity();
    this.paymentInfoForm.get('cardExpiration').updateValueAndValidity();
    this.paymentInfoForm.get('cvv').updateValueAndValidity();
    this.paymentInfoForm.get('street').updateValueAndValidity();
    this.paymentInfoForm.get('street2').updateValueAndValidity();
    this.paymentInfoForm.get('city').updateValueAndValidity();
    this.paymentInfoForm.get('state').updateValueAndValidity();
    this.paymentInfoForm.get('zip').updateValueAndValidity();
  }

  clearPaymentValidators() {
    this.paymentInfoForm.get('nameOnCard').clearValidators();
    this.paymentInfoForm.get('cardNumber').clearValidators();
    this.paymentInfoForm.get('cardExpiration').clearValidators();
    this.paymentInfoForm.get('cvv').clearValidators();
    this.paymentInfoForm.get('street').clearValidators();
    this.paymentInfoForm.get('city').clearValidators();
    this.paymentInfoForm.get('state').clearValidators();
    this.paymentInfoForm.get('zip').clearValidators();
    this.paymentInfoForm.get('routingNumber').clearValidators();
    this.paymentInfoForm.get('accountNumber1').clearValidators();
    this.paymentInfoForm.get('accountNumber2').clearValidators();

    this.paymentInfoForm.get('accountName').updateValueAndValidity();
    this.paymentInfoForm.get('routingNumber').updateValueAndValidity();
    this.paymentInfoForm.get('accountNumber1').updateValueAndValidity();
    this.paymentInfoForm.get('accountNumber2').updateValueAndValidity();
    this.paymentInfoForm.get('cardNumber').updateValueAndValidity();
    this.paymentInfoForm.get('cardExpiration').updateValueAndValidity();
    this.paymentInfoForm.get('cvv').updateValueAndValidity();
    this.paymentInfoForm.get('street').updateValueAndValidity();
    this.paymentInfoForm.get('city').updateValueAndValidity();
    this.paymentInfoForm.get('state').updateValueAndValidity();
    this.paymentInfoForm.get('zip').updateValueAndValidity();
  }
  submitPayment() {
    for (var i in this.paymentInfoForm.controls) {
      this.paymentInfoForm.controls[i].markAsTouched();
    }
    if (this.paymentType() == 2) {
      if (this.accountNumber1() != this.accountNumber2()) {
        this.accountNumbersMatchError = true;
      }
    }
    if (!this.paymentInfoForm.valid || this.accountNumbersMatchError) {
      return;
    }

    this.blockUI.start();
    var request = new SubmitPaymentRequest();
    request.paymentType = this.paymentType();

    request.cardNumber = this.cardNumber();
    request.cardExpiration = this.cardExpiration();
    request.cvv = this.cvv();
    request.billingStreet = this.street();
    request.billingStreet2 = this.street2();
    request.billingCity = this.city();
    request.billingState = this.state();
    request.billingZip = this.zip();
    if (this.paymentType() == 2) {
      request.nameOnAccount = this.accountName();
    }
    else {
      request.nameOnAccount = this.nameOnCard();
    }
    request.routingNumber = this.routingNumber();
    request.accountNumber1 = this.accountNumber1();
    request.accountNumber2 = this.accountNumber2();

    request.invoiceIds = this.invoiceIds;
    request.donationAmount = this.donationAmount;
    this.invoiceService.submitPayment(request)
      .subscribe({
        next: (data) => {
          return this.router.navigate(['/admin-portal/member/invoice-management']);
        },
        error: (err) => {
          console.log(err);
          this.notificationService.error(err.error.message);
          this.blockUI.stop();
        },
        complete: () => {
          this.blockUI.stop();
        }
      })
  }
  disableDonation(){
    this.donationActive = false;
    this.donationAmount = 0;
  }
}
